import React from "react";

type Props = { errors?: string[]; warnings?: string[] };

/**
 * Mensagens de regra devolvidas pelo backend (programação de férias, lançamento
 * de afastamento): erros em vermelho (impedem salvar), avisos em amarelo
 * (salvou, mas vale a atenção — ex.: aviso de férias fora do prazo).
 */
export default function RuleMessages({ errors = [], warnings = [] }: Props) {
  if (errors.length === 0 && warnings.length === 0) return null;
  return (
    <>
      {errors.length > 0 ? (
        <div className="dpNotice dpNotice--danger" role="alert">
          <ul className="dpRuleList">
            {errors.map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {warnings.length > 0 ? (
        <div className="dpNotice dpNotice--warning">
          <ul className="dpRuleList">
            {warnings.map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </>
  );
}
